import { api } from "@/lib/orgApi";

export const SMART_PHRASE_FORMATS = [
  { code: "richtext", display: "Rich Text" },
  { code: "plaintext", display: "Plain Text" },
];

export const SMART_PHRASE_STATUSES = [
  { code: "true", display: "Active" },
  { code: "false", display: "Inactive" },
];

export function formatLabel(code) {
  return SMART_PHRASE_FORMATS.find((o) => o.code === code)?.display || code || "";
}

export function statusLabel(active) {
  return active ? "Active" : "Inactive";
}

export function formatUpdated(iso) {
  if (!iso) return "—";
  const match = String(iso).match(/^(\d{4}-\d{2}-\d{2})/);
  if (!match) return iso;
  const [y, m, d] = match[1].split("-");
  return `${m}/${d}/${y}`;
}

export function plainTextFromContent(content, format) {
  if (!content) return "";
  if (format === "plaintext") return String(content);
  return String(content)
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n")
    .replace(/<\/div>/gi, "\n")
    .replace(/<\/li>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

export function countWordsAndChars(content, format) {
  const plain = plainTextFromContent(content, format);
  const characters = plain.length;
  const words = plain.trim() ? plain.trim().split(/\s+/).length : 0;
  return { words, characters };
}

export function smartPhrasesPath() {
  return "/smartphrases";
}

export function newSmartPhrasePath() {
  return "/smartphrases/new";
}

export function editSmartPhrasePath(id) {
  return `/smartphrases/${encodeURIComponent(id)}/edit`;
}

export async function listSmartPhrases({ q, active, format, owner } = {}) {
  const params = {};
  if (q) params.q = q;
  if (active != null && active !== "") params.active = active;
  if (format) params.format = format;
  if (owner) params.owner = owner;
  const { data } = await api.get("/smart-phrases", { params });
  return data;
}

export async function getSmartPhrase(id) {
  const { data } = await api.get(`/smart-phrases/${id}`);
  return data;
}

export async function createSmartPhrase(payload) {
  const { data } = await api.post("/smart-phrases", payload);
  return data;
}

export async function updateSmartPhrase(id, payload) {
  const { data } = await api.put(`/smart-phrases/${id}`, payload);
  return data;
}

export async function duplicateSmartPhrase(phrase) {
  const base = String(phrase?.name || "PHRASE").trim().toUpperCase().replace(/\s+/g, "");
  const suffix = "_COPY";
  let name = `${base}${suffix}`.slice(0, 80);
  const payload = {
    name,
    description: phrase?.description || "Duplicated SmartPhrase",
    content: phrase?.content || " ",
    format: phrase?.format === "plaintext" ? "plaintext" : "richtext",
    active: true,
  };
  try {
    return await createSmartPhrase(payload);
  } catch (err) {
    if (err?.response?.status !== 409) throw err;
    name = `${base}_COPY_${Date.now().toString(36).toUpperCase()}`.slice(0, 80);
    return createSmartPhrase({ ...payload, name });
  }
}
